/**
 * Where Clients & pros is, from the URL hash, so every view is a link that
 * can be shared:
 *
 * - `#customer` and `#customer?q=Sékou` are the search, with its query;
 * - `#customer/<userId>` is that customer's page, `#customer/<userId>?tab=jobs` one of its tabs.
 *
 * `subscription` only has something to show for a pro; the page leaves the
 * tab out for everyone else.
 */

export const CUSTOMER_TABS = ["overview", "subscription", "settings", "jobs", "audit"] as const;
export type CustomerTab = (typeof CUSTOMER_TABS)[number];

export type CustomerRoute = { kind: "search"; query: string } | { kind: "page"; userId: string; tab: CustomerTab };

export function parseCustomerHash(hash: string): CustomerRoute {
  const rest = hash.replace(/^#\/?customer/, "");
  const [path = "", search = ""] = rest.split("?", 2);
  const params = new URLSearchParams(search);
  const userId = decodeURIComponent(path.replace(/^\/+/, "").split("/")[0] ?? "").trim();
  if (userId) {
    const tab = params.get("tab");
    return {
      kind: "page",
      userId,
      tab: CUSTOMER_TABS.includes(tab as CustomerTab) ? (tab as CustomerTab) : "overview",
    };
  }
  return { kind: "search", query: params.get("q") ?? "" };
}

export function customerHref(userId: string, tab: CustomerTab = "overview"): string {
  const base = `#customer/${encodeURIComponent(userId)}`;
  return tab === "overview" ? base : `${base}?tab=${tab}`;
}

export function searchHref(query: string): string {
  const trimmed = query.trim();
  return trimmed ? `#customer?${new URLSearchParams({ q: trimmed }).toString()}` : "#customer";
}
